/* eslint-disable */
import { useMutation, useQuery } from 'react-query';
import axios from 'axios';
import { generateToastError } from '../../../utils';
import { queryKeys } from '../queryKeys';

// ==================== ENABLE/DISABLE 2FA ====================

/**
 * Enable Two-Factor Authentication for user
 */
export const useMutationEnable2FA = (toast, userToken, onSuccess) => {
  const queryFn = () =>
    axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/auth/2fa/enable`,
      {},
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

  return useMutation([queryKeys.enable2FA], queryFn, {
    enabled: false,
    refetchOnWindowFocus: false,
    onSuccess: (success) => {
      toast.success('Two-factor authentication has been enabled successfully');
      if (onSuccess) onSuccess(success.data);
    },
    onError: (error) => {
      generateToastError(toast, error);
    },
  });
};

/**
 * Disable Two-Factor Authentication for user
 */
export const useMutationDisable2FA = (toast, userToken, onSuccess) => {
  const queryFn = () =>
    axios.post(
      `${process.env.REACT_APP_SERVER_URL}/api/auth/2fa/disable`,
      {},
      {
        headers: {
          Authorization: `Bearer ${userToken}`,
          'Content-Type': 'application/json',
        },
      }
    );

  return useMutation([queryKeys.disable2FA], queryFn, {
    enabled: false,
    refetchOnWindowFocus: false,
    onSuccess: (success) => {
      toast.success('Two-factor authentication has been disabled');
      if (onSuccess) onSuccess(success.data);
    },
    onError: (error) => {
      generateToastError(toast, error);
    },
  });
};

// ==================== SEND OTP ====================

/**
 * Send OTP code to user's phone
 * @param {Object} payload - { email, phone }
 */
export const useMutationSendOTP = (toast, onSuccess) => {
  const queryFn = (payload) =>
    axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/2fa/send-otp`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

  return useMutation([queryKeys.sendOTP], queryFn, {
    enabled: false,
    refetchOnWindowFocus: false,
    onSuccess: (success) => {
      toast.success('Verification code has been sent to your phone');
      if (onSuccess) onSuccess(success.data);
    },
    onError: (error) => {
      generateToastError(toast, error);
    },
  });
};

// ==================== VERIFY OTP ====================

/**
 * Verify OTP code and complete login
 * @param {Object} payload - { email, otp }
 */
export const useMutationVerifyOTP = (toast, onSuccess) => {
  const queryFn = (payload) =>
    axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/2fa/verify-otp`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

  return useMutation([queryKeys.verifyOTP], queryFn, {
    enabled: false,
    refetchOnWindowFocus: false,
    onSuccess: (success) => {
      toast.success('Verification successful! Logging you in...');
      if (onSuccess) onSuccess(success.data);
    },
    onError: (error) => {
      generateToastError(toast, error);
    },
  });
};

// ==================== RESEND OTP ====================

/**
 * Resend OTP code to user's phone
 * @param {Object} payload - { email }
 */
export const useMutationResendOTP = (toast, onSuccess) => {
  const queryFn = (payload) =>
    axios.post(`${process.env.REACT_APP_SERVER_URL}/api/auth/2fa/resend-otp`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });

  return useMutation([queryKeys.resendOTP], queryFn, {
    enabled: false,
    refetchOnWindowFocus: false,
    onSuccess: (success) => {
      toast.success('A new verification code has been sent');
      if (onSuccess) onSuccess(success.data);
    },
    onError: (error) => {
      generateToastError(toast, error);
    },
  });
};

// ==================== CHECK 2FA STATUS ====================

/**
 * Check if user has 2FA enabled
 * @param {string} userToken - User authentication token
 */
export const useQueryCheck2FAStatus = (userToken, enabled = true) => {
  const queryKey = [queryKeys.check2FAStatus, userToken];
  const queryFn = () =>
    axios.get(`${process.env.REACT_APP_SERVER_URL}/api/auth/2fa/status`, {
      headers: {
        Authorization: `Bearer ${userToken}`,
      },
    });

  return useQuery(queryKey, queryFn, {
    enabled: enabled && !!userToken,
    refetchOnWindowFocus: false,
    retry: 1,
    onError: (error) => {
      console.error('Error checking 2FA status:', error);
    },
  });
};
